import { render, staticRenderFns } from "./verification-list.vue?vue&type=template&id=b88ba416"
import script from "./verification-list.vue?vue&type=script&lang=js"
export * from "./verification-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports